<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>
      <div class="content">
        <div class="container">
          <div v-bind:class="type">{{ text }}</div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
export default {
  components: {
  },
  data: function() {
    return {}
  },
  computed: {
    type: function() {
      return this.$root.$data.pageMsg.type;
    },
    text: function() {
      return this.$root.$data.pageMsg.text;
    }
  }
}
</script>




// WEBPACK FOOTER //
// message.vue?3a074bb8